export default function ImageLeftRight({ left, right }) {
	return (
		<section className="container ce_imageleftright">
			<div className="row">
				<div className={`col-12 col-md-6`}>
					<img src={left} />
				</div>
				<div className={`col-12 col-md-6`}>
					<img src={right} />
				</div>
			</div>
		</section>
	);
}
